<!--
 * @Author: Merlin
 * @Date: 2024-03-22 17:58:40
 * @LastEditors: Merlin
 * @LastEditTime: 2024-04-19 15:31:54
 * @Description: 
-->
<template>
    <!-- ↓ win -->
    <div v-if="handsUserState === 'win' && winAmount > 0"
        class="statusText statusText-win statusTextAnimation"
    >
        WIN:
        {{ getFixed(winAmount, 2) }}
        {{ currency.toUpperCase() }} 
    </div>
    <!-- ↓ equal -->
    <div v-if="handsUserState === 'equal'"
        class="statusText statusText-equal statusTextAnimation"
    >
        PUSH
    </div>
    <!-- 👆 以上是赢局&平局，是相对乐观的结果 --> 
    <!-- ↓ split -->
    <span v-if="handsUserState === 'split'"
        class="icon bluearrow"
    >
        <svg fill="none" width="16" height="10" viewBox="0 0 16 10" xmlns="http://www.w3.org/2000/svg" >
            <path fill="#2283F6" d="M6.58579 8.58579L1.41421 3.41421C0.154284 2.15428 1.04662 0 2.82843 0H13.1716C14.9534 0 15.8457 2.15428 14.5858 3.41421L9.41421 8.58579C8.63317 9.36684 7.36684 9.36684 6.58579 8.58579Z" > </path>
        </svg>
    </span>
    <!-- 👇 最下面是2种输，是不好的结果 -->
    <!-- ↓ lose -->
    <div v-if="handsUserState === 'lose'"
        class="statusText statusText-lose statusTextAnimation"
    >
        NO WIN
    </div>
    <!-- ↓ bust -->
    <div v-if="handsUserState === 'bust'"
        class="statusText statusText-lose statusTextAnimation"
    >
        <!-- ↓ 只有这项有语言变化，其它项都是固定的英语 -->
        {{$t('GameBlackJack.bust').toUpperCase()}}
    </div>
</template>

<script lang="ts" setup>
import type { userStatus } from '../ts/blackjackGame';

const props = defineProps({
    handsUserState: {
        type: String as PropType<userStatus>,
        required: true,
    },
    winAmount: {
        type: Number,
        default: 0,
    },
    currency: {
        type: String,
        default: '',
    }
});

</script>

<style lang="scss" scoped src="../style/blackjack-card.scss"></style>
